import {
  computed,
} from "vue";

import icons, {
  StandardIcons,
} from "../../../icons";

import {
  map,
} from "lodash-es";

export default function IconsAPI() {
  const iconsListStandard = computed(() => {
    return map(StandardIcons, (icon, key) => {
      return {
        id: key,
        label: key,
      };
    });
  });

  const iconsListAll = computed(() => {
    return map(icons, (icon, key) => {
      return {
        id: key,
        label: key,
      };
    });
  });

  return {
    iconsListAll,
    iconsListStandard,
  };
}
